import { useMutation, useQueryClient } from '@tanstack/react-query';
import { omit } from 'lodash';

import { DeclarationGoods } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  updatedGoodItems: DeclarationGoods[];
  declarationId: string;
  aiModuleMustRunAfterSave?: boolean;
  newPriceSaved?: number;
  storeSavedDeclaration: boolean;
}

export const saveGoodsItems = async ({ updatedGoodItems, declarationId, aiModuleMustRunAfterSave, newPriceSaved, storeSavedDeclaration = true }: HookProps) => {
  const goodItems = updatedGoodItems.map((goodItem) => {
    return omit(goodItem, ['commodityCode', 'dutiesAndTaxes', 'webScraping']) as DeclarationGoods;
  });

  const { data } = await request({
    path: `declarations/${declarationId}/save-multiple-good-items`,
    method: 'PATCH',
    authenticate: true,
    dataObject: { goodItems, aiModuleMustRunAfterSave, newPriceSaved },
  });
  return data;
};

export const useSaveGoodsItems = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveGoodsItems,
    onSuccess: (_, variables) => {
      if (variables.storeSavedDeclaration) {
        queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
      }
    },
    onError: (error) => {
      showErrorToast(error, `Error saving goods items!`);
    },
  });
};
